import React from "react";
import { Link } from "react-router-dom";
import "./b2bnav.css";

const B2bNav = () => {
    return (
        <div className="b2b-div-nav">
                    <ul>
                        <li><Link to="/b2b">Dashboard</Link></li>
                        <li><span></span></li>
                        <li><Link to="/">Stock Sales</Link></li>
                        <li><Link to="/b2bwholesaleorder">Wholesale Order</Link></li>
                        <li><Link to="/">Inventory Stocks</Link></li>
                        <li><Link to="/">Trucktronix Products</Link></li>
                        <li><span></span></li>
                        <li><Link to="/">Settings</Link></li>
                        <li><Link to="/">Notifications</Link></li>
                        <li><Link to="/">Message</Link></li>
                        <li><Link to="/">Logout</Link></li>
                    </ul>

                    <div className="div-copyright">
                        Copyright @ 2025
                    </div>
                </div>
    )
}

export default B2bNav;